<template>
  <div class="modal fade" tabindex="-1" data-backdrop="static">
    <div class="modal-dialog" style="width: 600px">
      <div class="modal-content">
        <form v-on:submit.prevent="submit">
          <div class="modal-header">
            <button class="close" type="button" @click="hide">
              <i class="fa fa-times"></i>
            </button>
            <h3>Adobe Preview URL</h3>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>Preview URL</label>
              <input
                ref="urlInput"
                class="form-control"
                type="text"
                v-model="urlInput"
                placeholder="https://assets.adobe.com/id/urn:aaid:sc:US:..."
                :class="{ 'is-invalid': validationError }"
              />
              <small class="text-muted">Enter the Adobe assets URL for this issue</small>
              <div class="invalid-feedback" v-if="validationError">{{ validationError }}</div>
            </div>
          </div>

          <div class="modal-footer">
            <button class="btn btn-link text-muted" @click="hide" type="button" :disabled="saving">
              Cancel
            </button>
            <button class="btn btn-primary" type="submit" :disabled="saving || !urlInput">
              <span v-if="saving">
                <i class="fa fa-circle-o-notch fa-spin"></i>
                Saving...
              </span>
              <span v-else>Save</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      currentUrl: {
        type: String,
        default: ''
      }
    },

    data() {
      return {
        urlInput: '',
        saving: false,
        isVisible: false,
        validationError: ''
      }
    },

    watch: {
      isVisible(visible) {
        if (visible) {
          this.urlInput = this.currentUrl || ''
          jQuery(this.$el).modal({show: true})
          // Focus input after Bootstrap modal is fully shown
          jQuery(this.$el).one('shown.bs.modal', () => {
            this.$refs.urlInput?.focus()
          })
        } else {
          jQuery(this.$el).modal('hide')
        }
      }
    },

    methods: {
      show() {
        this.validationError = ''
        this.isVisible = true
      },

      hide() {
        this.isVisible = false
      },

      async submit() {
        // Validate that it's an Adobe assets URL
        if (!this.urlInput.includes('assets.adobe.com')) {
          this.validationError = 'Please enter a valid Adobe assets URL (must contain "assets.adobe.com")'
          return
        }
        
        this.validationError = ''
        this.saving = true
        try {
          this.$emit('save', this.urlInput)
          // Wait a bit for the save to process
          await new Promise(resolve => setTimeout(resolve, 500))
          this.hide()
        } finally {
          this.saving = false
        }
      }
    }
  }
</script>
